var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-absolute card-top-buttons"},[_c('button',{staticClass:"btn btn-header-light icon-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"text-data-link simple-icon-refresh"})])])}
var staticRenderFns = []

export { render, staticRenderFns }